import React, { useEffect, useRef, useState } from 'react'
import { dotNumberBlurValidation, dotNumberValidation, makeAjax, respStatus, showMessage, url, withDotValidation } from '../../../../helpers/global_helper';
import { useSelector, useDispatch } from 'react-redux';
import { formatPrice } from "../../../NumberFormat";
import { withTranslation } from 'react-i18next';
import ErrorInnerPopup from '../../../Popups/ErrorInnerPopup';
import ErrorPopup from '../../../Popups/ErrorPopup';
import BetSuccessPopup from '../../../Popups/BetSuccessPopup';
import ConfirmBetDeskonPopup from '../../../Popups/ConfirmBetDeskonPopup';
import CancelledBetDeskonPopup from '../../../Popups/CancelledBetDeskonPopup';
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from '../GameClosedPopup';
import MarketClose from '../MarketClose';
import CommonBetHeader from '../CommonBetHeader';

const ColokBebas2D = (props) => {
  const dispatch = useDispatch();
  const device = useSelector(state => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const gameType = useSelector((state) => state.CommonConfig.gameType);

  const [rowsToShow, setRowsToShow] = useState(10);
  const [betValues, setBetValues] = useState(Array(rowsToShow).fill(''));
  const [discountValues, setDiscountValues] = useState(Array(rowsToShow).fill(''));
  const [payValues, setPayValues] = useState(Array(rowsToShow).fill(''));
  const [totalBetAmount, setTotalBetAmount] = useState(0);

  const [betsEnabled, setBetsEnabled] = useState(Array(rowsToShow).fill(false));
  const [bets, setBets] = useState({});
  const [belli, setBbelli] = useState({});
  const [diskon, setDiskon] = useState({});
  const [bolakBalik, setBolakBalik] = useState({});
  const [reqData, setReqData] = useState({
    isfullbet: null,
    gameId: null,
    gameType: "colokbebas2d",
    action: "process",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: []
  });
  const [inputValues, setInputValues] = useState({});
  const [invalidRows, setInvalidRows] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const inputRefs = useRef({});
  const [highlightRow, setHighlightRow] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false)
  const [respData, setRespData] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [focusIndex, setFocusIndex] = useState(null);
  const beliRefs = useRef(Array(rowsToShow).fill(null));
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [totals, setTotals] = useState([]);
  const [defaultValue, setDefaultvalue] = useState("");
  const [autoBetValue, setAutoBetValue] = useState("");
  const [prizeDiscount, setPrizeDiscount] = useState();

  const handleDeafultAutobetBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleDeafultAutobet = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": reqData.gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPrizeDiscount(response.data.showDisc);
    })
  }, [gameId])

  const handleAutoBetBlur = (value) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setAutoBetValue(value);
    }
  };

  const handleAutoBet = (value) => {
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    // Check if the value matches the regex
    if (regex.test(value)) {
      setAutoBetValue(value);
    } else {
    }
  }

  const handleAutoBetFocus = (rowIndex) => {
    if (autoBetValue !== "") {
      if (autoBetValue > betDiscount.showMax / 1000) {
        setErrorMessages(props.t("you_have_reached_max_bet_value"));
        setShowErrorPopup(true);
        return;
      }
      const currentRow = inputValues[rowIndex];
      if (currentRow?.number1 && currentRow?.number2) {
        const newInputValues = { ...inputValues };

        if (!newInputValues[rowIndex]?.buy) {
          newInputValues[rowIndex] = {
            ...newInputValues[rowIndex],
            buy: autoBetValue,
          };
          setInputValues(newInputValues);

          const buyValue = parseFloat(autoBetValue) * betDiscount.showMultiple;
          const discountValue = buyValue * (prizeDiscount / 100);
          const payValue = buyValue - discountValue;

          setDiscountValues((prev) => {
            const newDiscountValues = [...prev];
            newDiscountValues[rowIndex] = discountValue;
            return newDiscountValues;
          });

          setPayValues((prev) => {
            const newPayValues = [...prev];
            newPayValues[rowIndex] = payValue;
            return newPayValues;
          });

        }
      }
    }
  };

  useEffect(() => {
  }, [prizeDiscount])

  useEffect(() => {
    const totalPay = payValues.reduce((acc, curr) => acc + (parseFloat(curr) || 0), 0);
    setTotalBetAmount(totalPay);
  }, [payValues]);

  let dicountValue = 1000;
  const handleInputBlur = (e, rowIndex, columnName) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName);
  }

  const handleInputChange = (e, rowIndex, columnName) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      if (columnName === 'buy') {
        regex = /^\d*$/;
        value = withDotValidation(value);
      } else {
        regex = /^[0-9]*$/;
      }
    }
    setHighlightRow(false);
    setErrorMessages([]);
    setShowErrorPopup(false);
    const newInputValues = { ...inputValues };

    if (isNaN(value)) {
      value = ''; // Reset to empty value if not an integer
    }

    if (!regex.test(value)) {
      return true;
    }

    if (!value) {
      setPayValues((prev) => {
        const newPayValues = [...prev];
        newPayValues[rowIndex] = '';
        return newPayValues;
      });

      setDiscountValues(prev => {
        const newDiscountValues = [...prev];
        newDiscountValues[rowIndex] = '';
        return newDiscountValues;
      });
    }

    if (columnName === 'buy' && betDiscount && (value > betDiscount.showMax / 1000)) {
      setErrorMessages(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }

    if (!newInputValues[rowIndex]) {
      newInputValues[rowIndex] = { number1: '', number2: '', buy: '' };
    }
    if (columnName === 'number1' && value.length > 1) {
      newInputValues[rowIndex]['number2'] = value.slice(-1);

      value = value[0];

      columnName = 'number2';

      setTimeout(() => {
        inputRefs.current[`${rowIndex}-number2`].focus();
      }, 0);

    } else if (columnName === 'number1') {
      setTimeout(() => {
        inputRefs.current[`${rowIndex}-number2`].focus();
      }, 0);
    } else if (columnName === 'number2' && value.length > 1) {
      newInputValues[rowIndex]['buy'] += value.slice(1);
      // value = value[0];
      value[0] > 0 ? value = value[0] : value = '';

      columnName = 'buy';
      setTimeout(() => {
        inputRefs.current[`${rowIndex}-buy`].focus();
      }, 0);
    } else if (columnName === 'number2') {
      setTimeout(() => {
        inputRefs.current[`${rowIndex}-buy`].focus();
      }, 0);
    } else if (columnName === 'number1' && newInputValues[rowIndex]['number1'] && newInputValues[rowIndex]['number1'] === value) {
      return;
    } else if (columnName === 'number2' && newInputValues[rowIndex]['number2'] && newInputValues[rowIndex]['number2'] === value) {
      return;
    }
    newInputValues[rowIndex][columnName] = value;

    // Clear 'buy' field if either 'number1' or 'number2' is blank
    if ((columnName === 'number1' || columnName === 'number2') && value === '') {
      newInputValues[rowIndex]['buy'] = '';
    }
    setInputValues(newInputValues);

    // Clear discount and pay if 'buy' input is empty
    if (columnName === 'buy') {
      if (value === '') {
        setDiscountValues(prev => {
          const newDiscountValues = [...prev];
          newDiscountValues[rowIndex] = '';
          return newDiscountValues;
        });
        setPayValues(prev => {
          const newPayValues = [...prev];
          newPayValues[rowIndex] = '';
          return newPayValues;
        });
      } else {
        // If 'buy' input is not empty, proceed to calculate discount and pay
        const parsedBuyValue = parseFloat(value);
        if (!isNaN(parsedBuyValue)) {
          const discount = (parsedBuyValue * betDiscount.showMultiple) * (prizeDiscount / 100);
          const pay = (parsedBuyValue * betDiscount.showMultiple) - discount;

          // Update discount and pay state arrays
          setDiscountValues((prev) => {
            const newDiscountValues = [...prev];
            newDiscountValues[rowIndex] = discount;
            return newDiscountValues;
          });

          setPayValues((prev) => {
            const newPayValues = [...prev];
            newPayValues[rowIndex] = pay;
            return newPayValues;
          });
        }
      }
    }

    const rowValues = newInputValues[rowIndex];
    const isString = value => typeof value === 'string';
    const isTrimmedString = value => isString(value) && value.trim();
    // const isRowComplete = rowValues.number1 && rowValues.number2 && rowValues.buy;
    // const newInvalidRows = [...invalidRows];
    const isRowComplete = isTrimmedString(rowValues.number1) && isTrimmedString(rowValues.number2) && isTrimmedString(rowValues.buy);
    const newInvalidRows = [...invalidRows];

    if (rowValues.number1 && rowValues.number1 === rowValues.number2) {
      setErrorMessages(props.t("guess_number_should_not_be_the_same"));
      setShowErrorPopup(true);
      value = '';
      newInputValues[rowIndex][columnName] = value;
      if (!newInvalidRows.includes(rowIndex)) {
        newInvalidRows.push(rowIndex);
      }
    } else {
      const index = invalidRows.indexOf(rowIndex);
      if (index > -1) {
        invalidRows.splice(index, 1);
      }
    }

    if (!isRowComplete) {
      if (!newInvalidRows.includes(rowIndex)) {
        newInvalidRows.push(rowIndex);
      }
    } else {
      const index = newInvalidRows.indexOf(rowIndex);
      if (index > -1) {
        newInvalidRows.splice(index, 1);
      }
    }

    // setInvalidRows(newInvalidRows);
    const isRowEmpty = row =>
      !isTrimmedString(row.number1) &&
      !isTrimmedString(row.number2) &&
      !isTrimmedString(row.buy);

    // Remove empty rows from newInvalidRows
    for (let i = newInvalidRows.length - 1; i >= 0; i--) {
      const invalidRowIndex = newInvalidRows[i];
      if (isRowEmpty(newInputValues[invalidRowIndex])) {
        newInvalidRows.splice(i, 1);
      }
    }

    setInvalidRows(newInvalidRows);

    if (rowIndex > 0) {
      const prevRowValues = newInputValues[rowIndex - 1];
      if (!prevRowValues || !prevRowValues.number1 || !prevRowValues.number2 || !prevRowValues.buy) {
        return;
      }
    }

    const dataangka = Object.keys(newInputValues).map(key => {
      const row = newInputValues[key];
      return [row.number1 + row.number2, row.buy * betDiscount.showMultiple];
    });

    setReqData({
      ...reqData,
      dataangka: dataangka,
      gameId: gameId
    });
  };

  const handleInputFocusBelli = (e, rowIndex, columnName) => {
    const { name, value } = e.target;
    if (defaultValue !== "" && defaultValue !== undefined) {
      setBbelli((prevBelli) => ({
        ...prevBelli,
        [rowIndex]: defaultValue,
      }));

      const newInputValues = { ...inputValues };
      newInputValues[rowIndex][columnName] = defaultValue;
      setInputValues(newInputValues);
      let newDiskon = (defaultValue * prizeDiscount * betDiscount.showMultiple) / 100;

      let newBolakBalik = defaultValue * betDiscount.showMultiple - newDiskon;
      setTotals((previous) => {
        const updateTotal = [...previous]
        updateTotal[rowIndex] = newBolakBalik
        return updateTotal
      });

      setPayValues((prev) => {
        const newPayValues = [...prev];
        newPayValues[rowIndex] = newBolakBalik;
        return newPayValues;
      });

    }


  }

  const invalidStyle = {
    border: '2px solid red',
    backgroundColor: '#ffe6e6'
  };

  const confirmBet = () => {
    let betFinalValues;
    // if (device === "Desktop") {
    betFinalValues = Object.keys(inputValues)
      .filter(index => inputValues[index]?.number1 && inputValues[index]?.number2 && inputValues[index]?.buy) // Filter out incomplete rows
      .map(index => [inputValues[index].number1 + inputValues[index].number2, inputValues[index].buy * betDiscount.showMultiple]); // Create array of [combined number, buy * 1000] pairs
    const newReqData = {
      ...reqData,
      gameId: gameId,
      dataangka: betFinalValues
    };

    setReqData(newReqData);

    if (betFinalValues.length < 1) {
      setErrorMessages([props.t('guess_bet_wrong')]);
      setShowErrorPopup(true);
    } else {
      setShowConfirmationPopup(true);
    }
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(
      url.TOGEL_API.processAltTogel, reqData).then(response => {
        if (response.status !== respStatus['SUCCESS']) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            setErrorMessages(props.t(response.code));
            setShowErrorPopup(true);
            return;
          }
          setReqData({
            isfullbet: null,
            gameId: null,
            gameType: "colokbebas2d",
            action: "process",
            betTogelAuth: "betTogelAuth",
            allowPartner: "allowPartner",
            dataangka: []
          });
          showMessage(response);
          return;
        }
        setRespData(prevArray => [...prevArray, response.data]);
        dispatch(getUserBalance());
        setSuccessPopup(true);
        // setShowConfirmationPopup(false);
        resetBetData();
      });
  }

  useEffect(() => {
    resetBetData()
  }, [gameId])


  const resetBetData = () => {
    setInputValues({});
    setInvalidRows([]);
    setShowErrorPopup(false);
    setErrorMessages([]);
    setHighlightRow(false);
    setReqData({
      isfullbet: null,
      gameId: null,
      gameType: "colokbebas2d",
      action: "process",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: []
    });

    setAutoBetValue('')
    setDiscountValues(Array(rowsToShow).fill(''));
    setPayValues(Array(rowsToShow).fill(''));

    setBbelli([])
    setBets("")
    setDiskon("")
    setBolakBalik("")
    setTotals([]);
    setDefaultvalue('');
    setBetsEnabled(Array(rowsToShow).fill(false));
  }
  const rowDataReset = (rowIndex) => {
    const newBets = { ...bets };
    const newBelli = { ...belli }
    const newDiskon = { ...diskon };
    const newBolak = { ...bolakBalik };
    delete newBets[rowIndex];
    delete newBets['bets' + rowIndex + '' + 0];
    delete newBets['bets' + rowIndex + '' + 1];
    delete newBets['bets' + rowIndex + '' + 2];
    delete newBets['bets' + rowIndex + '' + 3];
    delete newBelli[rowIndex];
    delete newDiskon[rowIndex];
    delete newBolak[rowIndex];
    setBets(newBets);
    setBbelli(newBelli);
    setDiskon(newDiskon);
    setBolakBalik(newBolak);
    setBetsEnabled((prevEnabled) => {
      const newEnabled = [...prevEnabled];
      newEnabled[rowIndex] = false;
      return newEnabled;
    });
    const checkbox = document.getElementById(`checkValue${rowIndex}`);
    if (checkbox) {
      checkbox.checked = false;
    }
  }
  const handleClose = () => {
    setRespData([]);
    setSuccessPopup(false);
  }
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true)
  }
  const handleInputBetsChange = (e, rowIndex) => {
    const { name, value } = e.target;
    const onlyNumbers = value.replace(/[^0-9]/g, '');
    const newbets = {
      ...bets,
      [rowIndex]: onlyNumbers
    };
    if (onlyNumbers.length === 2 && onlyNumbers[0] === onlyNumbers[1]) {
      setErrorMessages(props.t('colok_bebas_different_number'));
      setShowErrorPopup(true);
      return;
    }
    setBets(newbets);
    if (onlyNumbers.length === 2) {
      setBetsEnabled((prevEnabled) => {
        const newEnabled = [...prevEnabled];
        newEnabled[rowIndex] = true;
        return newEnabled;
      });
      setFocusIndex(rowIndex);
    } else {
      setBetsEnabled((prevEnabled) => {
        const newEnabled = [...prevEnabled];
        newEnabled[rowIndex] = false;
        return newEnabled;
      });
    }
    if (onlyNumbers === "") {
      setBbelli((prevBelli) => {
        const newBelli = { ...prevBelli };
        delete newBelli[rowIndex];
        return newBelli;
      });

      setDiskon((prevDiskon) => {
        const newDiskon = { ...prevDiskon };
        delete newDiskon[rowIndex];
        return newDiskon;
      });

      setBolakBalik((prevBolakBalik) => {
        const newBolakBalik = { ...prevBolakBalik };
        delete newBolakBalik[rowIndex];
        return newBolakBalik;
      });
    }
  }
  const handleInputChangeBelli = (e, rowIndex) => {
    let newValues = e.target.value;
    let value = newValues ? newValues : "";
    let newDiskon = 0;
    let newBolakBalik = 0;
    const minAllowedValue = betDiscount.showMin / 1000;
    const maxAllowedValue = betDiscount.showMax / 1000;
    const numericValue = parseFloat(value);
    const regex = /^\d*$/;
    value = withDotValidation(value);
    if (regex.test(value)) {
      if (numericValue < minAllowedValue || numericValue > maxAllowedValue) {
        let errorMessage;
        // if (numericValue < minAllowedValue) {
        //   errorMessage = props.t("minimum_bet_is_") + ` ${minAllowedValue}`;
        // } else 
        if (numericValue > maxAllowedValue) {
          errorMessage = props.t('you_have_reached_max_bet_value');
        }
        setErrorMessages([errorMessage]);
        setShowErrorPopup(true);
        return;
      }
      if (value) {
        newDiskon = (numericValue * betDiscount.showDisc * dicountValue) / 100;
        newBolakBalik = numericValue * dicountValue - newDiskon;
      }
      setBbelli((prevBelli) => ({
        ...prevBelli,
        [rowIndex]: value,
      }));
      setBolakBalik((prevBolakBalik) => ({
        ...prevBolakBalik,
        [rowIndex]: newBolakBalik,
      }));
      setDiskon((prevDiskon) => ({
        ...prevDiskon,
        [rowIndex]: newDiskon,
      }));
    }
  };
  useEffect(() => {
    if (focusIndex !== null) {
      beliRefs.current[focusIndex].focus();
      setFocusIndex(null);
    }
  }, [focusIndex, betsEnabled]);
  return (
    <div className='colokbebasTwoD_wrapper'>
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {device === "Desktop" ?
            <div className="colokbebasTwoD_container">
              <div>
                <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} />
              </div>
              <table>
                <thead>
                  <tr className="Heading">
                    <th >{props.t('no.')}</th>
                    <th>{props.t('number')} 1</th>
                    <th>{props.t('number')} 2</th>
                    <th>
                      <input
                        type="text"
                        placeholder="Auto Bet"
                        value={autoBetValue}
                        onChange={(e) => handleAutoBet(e.target.value)}
                        onBlur={(e) => handleAutoBetBlur(e.target.value)}
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]**"
                      />
                    </th>
                    <th>{props.t('discount')}</th>
                    <th>{props.t('pay')}</th>
                  </tr>
                </thead>
                <tbody>

                  {
                    [...Array(rowsToShow)].map((_, index) => {
                      const isPreviousRowComplete = index === 0 || (
                        inputValues[index - 1]
                      );
                      return (
                        <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                          <td>{index + 1}</td>
                          <td className="inputs">
                            <input
                              type="text"
                              value={inputValues[index]?.number1 || ''}
                              onChange={(e) => handleInputChange(e, index, 'number1')}
                              style={invalidRows.includes(index) && highlightRow && !inputValues[index]?.number1 ? invalidStyle : {}}
                            // disabled={!isPreviousRowComplete}
                            />
                          </td>
                          <td className="inputs">
                            <input
                              type="text"
                              value={inputValues[index]?.number2 || ''}
                              onChange={(e) => handleInputChange(e, index, 'number2')}
                              style={invalidRows.includes(index) && highlightRow && !inputValues[index]?.number2 ? invalidStyle : {}}
                              // disabled={!isPreviousRowComplete}
                              ref={el => inputRefs.current[`${index}-number2`] = el}
                            />
                          </td>
                          <td className="inputs">
                            <input
                              type="text"
                              placeholder="Bet"
                              value={inputValues[index]?.buy || ''}
                              onChange={(e) => handleInputChange(e, index, 'buy')}
                              onBlur={(e) => handleInputBlur(e, index, 'buy')}
                              className={invalidRows.includes(index) && highlightRow && !inputValues[index]?.buy ? "invalidStyle" : "validStyle"}
                              disabled={!(inputValues[index]?.number1 && inputValues[index]?.number2)}
                              ref={el => inputRefs.current[`${index}-buy`] = el}
                              // className='input-bg'
                              onFocus={() => handleAutoBetFocus(index)}
                            />
                          </td>
                          <td className="inputs">
                            <input
                              name={index}
                              type="text"
                              value={formatPrice(discountValues[index])}
                              readOnly
                              disabled={!(inputValues[index]?.number1 && inputValues[index]?.number2)}
                            />
                          </td>
                          <td className="inputs">
                            <input
                              name={index}
                              type="text"
                              value={formatPrice(payValues[index])}
                              disabled={!(inputValues[index]?.number1 && inputValues[index]?.number2)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            :
            <div className="colokbebasTwoD_container_mobile">

              <div className='container'>
                <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} />
                {/* <table>
              <thead>
                <tr>
                  <th>{props.t('no.')}</th>
                  <th>{props.t('guess')}</th>
                  <th>{props.t('buy')}<span className='small_input'> 1=1000</span></th>
                  <th>{props.t('discount')}</th>
                  <th>{props.t('pay')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {[...Array(rowsToShow)].map((_, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td><input type='text'
                      maxLength="2"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      name={`bets${index}`}
                      value={(bets[index] ? bets[index] : "")}
                      onChange={(e) => handleInputBetsChange(e, index, 'Bets')}
                      autocomplete="off"
                    /></td>
                    <td><input type='text'
                      maxlength="100"
                      placeholder='1 = 1,000 IDR'
                      inputMode="numeric"
                      pattern="[0-9]*"
                      name={`${index}`} value={(belli)[index] ? (belli)[index] : ''}
                      onChange={(e) => handleInputChangeBelli(e, index, 'Belli')}
                      disabled={!betsEnabled[index]}
                      ref={el => beliRefs.current[index] = el}
                      autocomplete="off"
                    /></td>
                    <td><input type='text' name={index}
                      readOnly tabindex="-1"
                      value={(diskon)[index] ? (diskon)[index] : ''}

                        /></td>
                        <td><input
                          name={index} readOnly tabindex="-1"
                          type="text" value={(bolakBalik)[index] ? (bolakBalik)[index] : ''}
                        /></td>
                        <td><button
                          onClick={(e) => rowDataReset(index)} tabindex="-1"
                          className='reset-button'>reset</button></td>
                      </tr>
                    ))}

                  </tbody>
                </table> */}

                <table>
                  <thead>

                    <tr className="Heading">
                      <th colSpan={2}>{props.t('no.')}</th>
                      <th>{props.t('guess')}1</th>
                      <th>{props.t('guess')}2</th>
                      {/* <th> {props.t('bet')} <span className="small_input">1=1000</span></th> */}
                      <th colSpan={2}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue}
                          onChange={(e) => handleDeafultAutobet(e)}
                          onBlur={(e) => handleDeafultAutobetBlur(e)}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      [...Array(rowsToShow)].map((_, index) => {
                        const isPreviousRowComplete = index === 0 || (
                          inputValues[index - 1]
                        );
                        return (
                          <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                            <td colSpan={2}>{index + 1}</td>
                            <td className="inputs">
                              <input
                                type="text"
                                value={inputValues[index]?.number1 || ''}
                                onChange={(e) => handleInputChange(e, index, 'number1')}
                                style={invalidRows.includes(index) && highlightRow && !inputValues[index]?.number1 ? invalidStyle : {}}
                              // disabled={!isPreviousRowComplete}
                              />
                            </td>
                            <td className="inputs">
                              <input
                                type="text"
                                value={inputValues[index]?.number2 || ''}
                                onChange={(e) => handleInputChange(e, index, 'number2')}
                                style={invalidRows.includes(index) && highlightRow && !inputValues[index]?.number2 ? invalidStyle : {}}
                                // disabled={!isPreviousRowComplete}
                                ref={el => inputRefs.current[`${index}-number2`] = el}
                              />
                            </td>
                            <td className="inputs" colSpan={2}>
                              <input
                                type="text"
                                placeholder="Bet"
                                value={inputValues[index]?.buy || ''}
                                onChange={(e) => handleInputChange(e, index, 'buy')}
                                onFocus={(e) => handleInputFocusBelli(e, index, 'buy')}
                                onBlur={(e) => handleInputBlur(e, index, 'buy')}
                                className={invalidRows.includes(index) && highlightRow && !inputValues[index]?.buy ? "invalidStyle" : "validStyle"}
                                disabled={!(inputValues[index]?.number1 && inputValues[index]?.number2)}
                                ref={el => inputRefs.current[`${index}-buy`] = el}
                                inputMode="decimal"
                                pattern="^[0-9]*[.,]?[0-9]*$"
                              // className='input-bg'
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>}
          <div className="last_div">
            <div className="left_div">
              {/* <p>Menebak bebas 2 angka dari 4D.</p> */}
              <p>{props.t('guess_two_4d')}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={resetBetData}>{props.t('reset')}</button>
                </li>
                <li>
                  <button className="submit" onClick={confirmBet}>{props.t('submit')}</button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup message={errorMessages} onClose={() => setShowErrorPopup(false)} />
        </ErrorInnerPopup>
      )}
      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose} submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup
          onClose={() => setShowCanclledPopup(false)}

        />
      )}
      {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup response={respData} onClose={() => handleClose()} />
        </div>
      )}
    </div>
  )
}

export default withTranslation()(ColokBebas2D)
